/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { AvailableLanguage } from '@app/app/shared/models/organization/organization.model';
import { ButtonComponent, ButtonSizes } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { LucideLanguages } from '@lucide/angular';
import { TranslocoModule } from '@ngneat/transloco';

/**
 * Picks the language a piece of content is read in. Shared by every learner view that offers it, so
 * a programme, a card and an event all switch language through the same control.
 */
@Component({
  selector: 'ptl-content-language-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMenuModule, TranslocoModule, ButtonComponent],
  templateUrl: './content-language-menu.component.html',
})
export class ContentLanguageMenuComponent {
  readonly languages = input<AvailableLanguage[]>([]);
  readonly selectedCode = input<string | null>(null);
  /** Matches the buttons it sits next to, which differ per surface. */
  readonly size = input<ButtonSizes>('s');
  readonly languageSelected = output<string>();

  protected readonly LucideLanguages = LucideLanguages;
}
